import {NumberFormatOptions, NumberFormatter} from '@internationalized/number';
import {useMemo} from 'react';
import {useSelectedLocale} from '@ui/i18n/selected-locale';

export function useNumberFormatter(
  options: NumberFormatOptions = {},
  localeOverride?: string,
): Intl.NumberFormat {
  const {localeCode} = useSelectedLocale();
  const locale = localeOverride || localeCode;
  return useMemo(
    () => new NumberFormatter(locale, options),
    [locale, options],
  );
}
